import { action } from 'typesafe-actions';

import { IPrivacyPolicy, PrivacyPolicyTypes } from './types';

export const setConsentGiven = (consent: boolean) =>
  action(PrivacyPolicyTypes.SET_CONSENT_GIVEN, consent);
export const loadRequest = () => action(PrivacyPolicyTypes.LOAD_REQUEST);
export const loadFailure = () => action(PrivacyPolicyTypes.LOAD_FAILURE);
export const loadSuccess = (data: IPrivacyPolicy) => action(PrivacyPolicyTypes.LOAD_SUCCESS, data);
